const stickyHubNav = () => {
    const hubNav = document.querySelector('body.lab_permanent_header header .top-nav');
    const windowScroll = window.pageYOffset;

    if (hubNav) {

        if (document.querySelector('body.lab_permanent_header header.uf-stream-banner-marketing') || document.querySelector('body.lab_permanent_header header .large-header')) {
            const header = document.querySelector('body.lab_permanent_header header.uf-stream-banner-marketing') || document.querySelector('body.lab_permanent_header header .large-header');
        
            const headerHeight = parseInt(header.offsetHeight) - 10;
          
            if (headerHeight) {
                if (windowScroll === 0 && hubNav.classList.contains('sticky')) {
                    hubNav.classList.remove('sticky');
                }
                if (windowScroll > headerHeight && !hubNav.classList.contains('sticky')) {
                    hubNav.classList.add('sticky');
                } else if (hubNav.classList.contains('sticky') && windowScroll < headerHeight) {
                    hubNav.classList.remove('sticky');
                }
            }

        } else {
            if (!hubNav.classList.contains('sticky') && windowScroll > 0) {
                hubNav.classList.add('sticky');  
            }
            if (windowScroll === 0 && hubNav.classList.contains('sticky')) {
                hubNav.classList.remove('sticky');
            }
            
        }
       
    }
};


export { stickyHubNav };



// WEBPACK FOOTER //
// ./scriptPartials/hubSpecificFunctions/hubNav.js